export default {
  g: "{value} g",
  kg: "{value} kg",
  t: "{value} t",
  lb: "{value} lb",
  st: "{value} st",
};
